import React from 'react';
import { LoaderSpin, LoaderSpinProps } from './LoaderSpin';
import { OnPageLoaderContainer } from './OnPageLoaderContainer';

export interface LoadingPageBodyProps extends LoaderSpinProps {}

/**
 * Body della Pagina di caricamento generica.
 */
export function LoadingPageBody(props: LoadingPageBodyProps) {
  return (
    // <ResponsiveCard noPadding>
    <OnPageLoaderContainer>
      <LoaderSpin transparent {...props} />
    </OnPageLoaderContainer>
    // </ResponsiveCard>
  );
}
